import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const LETTER_WIDTH_MM = 215.9;
const LETTER_HEIGHT_MM = 279.4;
const DEFAULT_SCALE = 3;
const JPEG_QUALITY = 0.92;

function getPageMetrics(orientation = 'portrait') {
    if (orientation === 'landscape') {
        return {
            width: LETTER_HEIGHT_MM,
            height: LETTER_WIDTH_MM,
        };
    }

    return {
        width: LETTER_WIDTH_MM,
        height: LETTER_HEIGHT_MM,
    };
}

async function waitForFonts() {
    if (!document?.fonts?.ready) return;

    try {
        await document.fonts.ready;
    } catch (_) {
        // Si el navegador no resuelve correctamente fonts.ready, seguimos con la captura.
    }
}

/**
 * Renderiza cada .pdf-page por separado y las combina en un PDF.
 * Evita el límite de canvas del navegador en documentos extensos
 * y usa JPEG para mantener el documento bajo el límite de string de JS.
 *
 * @param {HTMLElement} container
 * @param {{ scale?: number, orientation?: 'portrait' | 'landscape', onProgress?: (current: number, total: number) => void }} opts
 */
async function renderPageByPage(container, { scale = DEFAULT_SCALE, orientation = 'portrait', onProgress } = {}) {
    await waitForFonts();

    const pages = container.querySelectorAll('.pdf-page');
    if (!pages.length) return null;

    const page = getPageMetrics(orientation);
    const pdf = new jsPDF({ unit: 'mm', format: 'letter', orientation });
    const total = pages.length;

    for (let i = 0; i < total; i++) {
        if (onProgress) onProgress(i + 1, total);

        const canvas = await html2canvas(pages[i], {
            scale,
            useCORS: true,
            backgroundColor: '#ffffff',
            logging: false,
        });

        const imgData = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, 0, page.width, page.height, undefined, 'FAST');
    }

    return pdf;
}

export async function downloadPdf(container, { filename, scale, orientation, onProgress } = {}) {
    if (!container) return;
    const pdf = await renderPageByPage(container, { scale, orientation, onProgress });
    if (pdf) pdf.save(filename || 'reporte.pdf');
}

export async function openPdf(container, { filename, scale, orientation, onProgress } = {}) {
    if (!container) return;
    const pdf = await renderPageByPage(container, { scale, orientation, onProgress });
    if (pdf) {
        const pdfString = pdf.output('datauristring');
        const win = window.open();
        if (win) win.document.write(`<iframe width='100%' height='100%' src='${pdfString}'></iframe>`);
    }
}
